import { postCode, imageField, marketingPhotoField } from '../stepper/stepper-functions';

$(function() {
    let $currentForm = $('#profileForm');

    function reloadMap() {
        let coordinate = [];
        $currentForm.find('#postCode').children('.item-pc').each(function() {
            let radius = parseFloat($(this).children('.input-post-code').children('.input-radius').val());
            let lat = parseFloat($(this).children('.input-post-code').children('.input-lat').val());
            let lng = parseFloat($(this).children('.input-post-code').children('.input-lng').val());
            coordinate.push({ lat, lng, radius });
        });
        postCode.$formElement = $currentForm;
        postCode.coordinate = coordinate;
        postCode.showMap();
    }
    
    switch ($currentForm.children('input[name="type"]').val()) {
        case 'general_information': {
            break;
        }
        case 'location': {
            reloadMap();
            $currentForm.find('#addPostCode').on('click', function (e) {
                e.preventDefault();
                postCode.addItem($currentForm);
            });
            $currentForm.find('select[name="radius"]').change(function (e) {
                e.preventDefault();
                let postcode = $currentForm.find('input[name="postcode"]').val();
                let radius = $currentForm.find('select[name="radius"] :selected').val();
                if (postcode !== '' && radius !== 'none') {
                    if (postCode.postCodeCount !== postCode.maxSelectPostcode) {
                        postCode.addDisabledButton($currentForm, true);
                    }
                }
            });
            $currentForm.find('input[name="postcode"]').on('change', function () {
                if($(this).val() !== '') {
                    $currentForm.find('input[name="postcode"]').removeClass('is-invalid');
                }
            });
            break;
        }
        case 'broker_details': {
            let change = false;
            let href = '';
            $currentForm.find('.file-link').children('.label-link').on('click', function (e) {
                e.preventDefault();
                imageField.triggerFile($currentForm);
            });
            $currentForm.find('.form-group').children('input[type="file"]').change(function () {
                imageField.changeFile($(this));
            });
            $currentForm.find('#remove-firm-logo').on('click', function (e) {
                e.preventDefault();
                imageField.removeFile($(this));
            });
            $currentForm.find('.file-link').children('.upload-markrting-link').on('click', function (e) {
                e.preventDefault();
                marketingPhotoField.triggerFile($currentForm);
            });
            $currentForm.find('input[name="broker_name"]').on('change', function() {
                change = true;
            });
            $('.broker-details').find('a').on('click', function (e) {
                href = $(this).attr('href');
                if(change) {
                    e.preventDefault();
                    $('#confirmModal').modal('show');
                }
            });
            $('.broker-details').find('#leaveConfirmButton').on('click', function (e) {
               e.preventDefault();
                window.location = href;
            });
            $('.broker-details').find('#saveConfirmButton').on('click', function (e) {
                e.preventDefault();
                $currentForm.find('button[type="submit"]').click();
            });
            break;
        }
        case 'specialties': {
            break;
        }
    }

    $('#addPostCodeProfile').on('click', function (e) {
        e.preventDefault();
    });

    $('#showProfileNavigation').on('click', function (e) {
        e.preventDefault();
        if(!$(this).hasClass('is-active')) {
            $(this).addClass('is-active');
            $('.navigation-profile').addClass('is-active');
            $('.navigation-profile__shadow').removeClass('d-none');
        } else {
            $(this).removeClass('is-active');
            $('.navigation-profile').removeClass('is-active');
            $('.navigation-profile__shadow').addClass('d-none');
        }
    });

    jQuery(document).on('click', '.remove-post-code', function (e) {
        e.preventDefault();
        reloadMap();
    });

    let forms = document.getElementsByClassName('profile-form');
    Array.prototype.filter.call(forms, function(form) {
        form.addEventListener('submit', function(event) {
            if (form.checkValidity() === false) {
                event.preventDefault();
                event.stopPropagation();
            } else {
                event.preventDefault();
                event.stopPropagation();
                if($currentForm.children('input[name="type"]').val() === 'location') {
                    let $checkNationwide = $currentForm.find('input[name="nationwide"]');
                    if(!$checkNationwide.is(':checked') && $currentForm.find('#postCode').children('.col-xl-4').size() === 0) {
                        $currentForm.find('input[name="postcode"]').addClass('is-invalid');
                        return;
                    } else {
                        $currentForm.find('input[name="postcode"]').removeClass('is-invalid');
                    }
                }
                let formData = new FormData(this);
                $.ajax({
                    url: window.ajax_url,
                    data: formData,
                    type: 'POST',
                    processData: false,
                    contentType: false,
                }).done(function (res) {
                    let response = JSON.parse(res);
                    if(response.status) {
                        window.location.reload();
                    }
                }).fail(function (error) {
                    console.log(error);
                });
            }
            form.classList.add('was-validated');
        }, false);
    });

    $('#updatePackageForm').on('submit', function (e) {
        e.preventDefault();
        let formData = new FormData(this);
        $.ajax({
            url: window.ajax_url,
            data: formData,
            type: 'POST',
            processData: false,
            contentType: false,
        }).done(function (res) {
            let response = JSON.parse(res);
            if(response.checkout_session !== '') {
                window.location = response.checkout_session.url;
            }
        }).fail(function (error) {
            console.log(error);
        });
    });
});


// WEBPACK FOOTER //
// ./scripts/routes/profile.js